import React, { useEffect, useState } from "react";
import mammoth from "mammoth";
import ScrollToTopButton from "../../../components/ScrollertoTop";
import Skeleton from "react-loading-skeleton";

const DocxApp = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [toggle, setToggle] = useState(false);
  useEffect(() => {
    fetch('/whitepaper_docs.docx') // Replace with your actual file name in public/
      .then((res) => res.arrayBuffer())
      .then((arrayBuffer) => mammoth.convertToHtml({ arrayBuffer }))
      .then(({ value }) => {
        // Highlight dtoc keywords
        const styledHtml = value
          .replace(/The Rise of Web3: Taking Back Control!/g, '<span class="dtoc-highlight">The Rise of Web3: Taking Back Control!</span>')
          .replace(/INDEX/g, '<span class="dtoc-highlight">INDEX</span>');
        setHtmlContent(styledHtml);
        setToggle(true)
      })
      .catch((err) => console.error('Error loading docx:', err));
  }, []);

  return (
    <>
      <div style={styles.container}>
        {toggle ?
          <div style={styles.contentWrapper}>
            <div
              style={styles.preview}
              className="docx-preview"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
            {/* <div style={styles.editor}>
          <Editor editorState={editorState} onChange={setEditorState} />
        </div> */}
          </div>
          :
          <div className="">
            <div className="m-5 space-y-10">
              <Skeleton height={20} width="80%" />
              <div className="card_head">
                <Skeleton
                  height={"70vh"}
                  width="100%"
                  style={{ paddingTop: "-1rem" }}
                />
              </div>
              <div className="card_footer d-block space-y-10">
                <Skeleton height={15} width="50%" />
              </div>
            </div>
          </div>
        }
      </div>
      <ScrollToTopButton />
    </>
  );
};

const styles = {
  container: {
    // padding: "20px",
    fontFamily: "Arial, sans-serif",
    boxSizing: "border-box",
    maxWidth: "100%",
  },
  inputWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginBottom: "20px",
  },
  fileInput: {
    flex: "1 1 auto",
    minWidth: "200px",
  },
  button: {
    padding: "10px 15px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    // backgroundColor:"#003000",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
    whiteSpace: "nowrap",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    // width:"70vw",
    gap: "20px",
  },

  preview: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: "#4CAF50",
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "4px",
    backgroundColor: "rgb(151 22 22 / 13%)",
  },
  previewContent: {
    width: "100%",
  },
  editor: {
    minHeight: "150px",
    // width:"60vw",
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "4px",
    backgroundColor: "#fff",
  },
  "@media (min-width: 768px)": {
    contentWrapper: {
      flexDirection: "row",
    },
    preview: {
      flex: 1,
    },
    editor: {
      flex: 1,
    },
  },
};

export default DocxApp;
